<template>
  <div>
  </div>
</template>

<script>
import { getPendingBonuses, consumePendingBonus, getHistoricalPendingBonsuses } from '../api/rewards';

export default {
  name: 'PendingRewards',
  props: {
    authToken: {
      type: String,
    },
    userId: {
      type: Number,
    },
    brandId: {
      type: Number,
    },
    brandName: {
      type: String,
    },
    prismaUrl: {
      type: String,
    },
    fusionUrl: {
      type: String,
    },
  },
  watch: {
    prismaUrl() {
      if (typeof window !== 'undefined' && window.dispatchEvent && this.prismaUrl && this.prismaUrl !== '') {
        const event = new Event('fasttrack-crm-pendingbonus-ready');
        window.dispatchEvent(event);
      }
    },
  },
  methods: {
    getHistoricalPendingBonsuses() {
      return new Promise((resolve, reject) => {
        getHistoricalPendingBonsuses(this.authToken, this.prismaUrl, this.fusionUrl)
          .then((response) => {
            if (!response.data.Success) {
              reject(response.data.Errors);
              return;
            }
            resolve(response.data.Data);
          })
          .catch(reject);
      });
    },
    getPendingBonuses() {
      return new Promise((resolve, reject) => {
        getPendingBonuses(this.authToken, this.prismaUrl, this.fusionUrl)
          .then((response) => {
            if (!response.data.Success) {
              reject(response.data.Errors);
              return;
            }
            resolve(response.data.Data);
          })
          .catch(reject);
      });
    },
    consumePendingReward(bonusId) {
      return new Promise((resolve, reject) => {
        consumePendingBonus(this.authToken, this.prismaUrl, bonusId, this.fusionUrl)
          .then((response) => {
            if (!response.data.Success) {
              reject(response.data.Errors);
              return;
            }
            resolve(response.data.Data);
          })
          .catch(reject);
      });
    },
  },
};
</script>

<style>
</style>
